import {
  AppBar,
  Toolbar,
  IconButton
  // Menu,
  // MenuItem
} from "@mui/material";
import { Icon } from "@iconify/react";
import MenuIcon from "@mui/icons-material/Menu";
import { useLayoutState, useLayoutDispatch, toggleSidebar } from "../../context/LayoutContext";
import { useUserState } from "../../context/UserContext";
import classNames from "classnames";
import { useTheme } from "@mui/material/styles";
import logo from "../../assets/images/logo.svg";

// styles
import useStyles from "./styles";

const Header = () => {
  const classes = useStyles();
  const { appLogo } = useUserState();
  const { isSidebarOpened } = useLayoutState();
  const theme = useTheme();
  const windowWidth = window.innerWidth;
  const breakpointWidth = theme.breakpoints.values.md;
  const isSmallScreen = windowWidth < breakpointWidth;

  const layoutDispatch = useLayoutDispatch();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>

        <div className={classes.logotype}>
          <img src={appLogo || logo} alt="App logo" className={classes.logo} />
        </div>
        {process.env.REACT_APP_ENVIRONMENT === "development" ? (
          <div className={classes.environment}>Dev</div>
        ) : process.env.REACT_APP_ENVIRONMENT === "staging" ? (
          <div className={classes.environment}>staging</div>
        ) : process.env.REACT_APP_ENVIRONMENT === "sandbox" ? (
          <div className={classes.environment}>sandbox</div>
        ) : null}
        <Icon icon="icon-park-outline:avatar" />
        {/* <IconButton
          color="inherit"
          aria-haspopup="true"
          aria-controls="mail-menu"
          open={notificationTab}
          aria-expanded="false"
          onClick={handleClickNotificationIcon}
          className={classes.headerMenuButton}
          style={{ padding: 0 }}
        >
          <div className={classes.alertbadge}>{unReadNotifications?.length || 0}</div>
          <div className={classes.initials}>
            <Icon icon="clarity:notification-solid" width="17" height="17" />
          </div>
        </IconButton> */}
        {isSmallScreen && !isSidebarOpened && (
          <div className={classes.mobileBackButton}>
            <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
              <MenuIcon
                classes={{
                  root: classNames(classes.headerIcon, classes.headerIconCollapse)
                }}
              />
            </IconButton>
          </div>
        )}

      </Toolbar>
    </AppBar>
  );
};

export default Header;
